// extracted by mini-css-extract-plugin
module.exports = {"regularPanel":"Panel_regularPanel__3VmfW","isAdmin":"Panel_isAdmin__15XEg","panelFieldset":"Panel_panelFieldset__1rZLD","panelLegend":"Panel_panelLegend__1AQPQ"};